import { FC } from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/UI/Dialog/Dialog";

interface VideoProps {
  video_src: string;
  isDialogOpen: boolean;
  setIsDialogOpen: (open: boolean) => void;
}

const Video: FC<VideoProps> = ({
  video_src,
  isDialogOpen,
  setIsDialogOpen,
}) => {
  return (
    <>
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        {/* <DialogTrigger>Open</DialogTrigger> */}
        <DialogContent className="items-center justify-center border-none bg-transparent shadow-none">
          <DialogHeader className="hidden">
            <DialogTitle></DialogTitle>
            <DialogDescription></DialogDescription>
          </DialogHeader>
          <video
            preload="auto"
            className="ring-grey rounded-lg ring-8"
            width="320"
            controls
            autoPlay
          >
            <source src={video_src} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Video;
